var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("dataScreening", {
            attrs: {
              propsData: {
                isCountry: false,
                adChannel: false,
                adPlacement: false,
                isDate: false
              }
            },
            on: { searchChange: _vm.searchChange }
          }),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-date-picker", {
                staticStyle: { "min-width": "237px" },
                attrs: {
                  clearable: false,
                  "picker-options": _vm.pickerOptionsRadius,
                  "value-format": "yyyy-MM-dd",
                  type: "daterange",
                  align: "right",
                  "range-separator": _vm.$t("to"),
                  "start-placeholder": _vm.$t("startDate"),
                  "end-placeholder": _vm.$t("endDate")
                },
                model: {
                  value: _vm.date,
                  callback: function($$v) {
                    _vm.date = $$v
                  },
                  expression: "date"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("userId") },
                model: {
                  value: _vm.paramsData.user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "user_id", $$v)
                  },
                  expression: "paramsData.user_id"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: _vm.$t("roleIdsPlaceholder")
                },
                model: {
                  value: _vm.paramsData.role_ids,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "role_ids", $$v)
                  },
                  expression: "paramsData.role_ids"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: _vm.$t("type")
                  },
                  model: {
                    value: _vm.paramsData.task_type,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "task_type", $$v)
                    },
                    expression: "paramsData.task_type"
                  }
                },
                _vm._l(_vm.typeList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: _vm.$t("enterLevel") },
                model: {
                  value: _vm.paramsData.task,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "task", $$v)
                  },
                  expression: "paramsData.task"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList(_vm.paramsData.page)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("search")) + " ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _vm.tableData.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.exportLoading },
                      on: { click: _vm.exportdata }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("export")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          attrs: { data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "game", label: _vm.$t("game"), "min-width": "120" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "platform",
              label: _vm.$t("platform"),
              "min-width": "80"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channel",
              label: _vm.$t("channel"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pkg",
              label: _vm.$t("packageName"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "user_id",
              label: _vm.$t("userId"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "server_id",
              label: _vm.$t("serverId"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_name",
              label: _vm.$t("roleName"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "role_id",
              label: _vm.$t("roleId"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "time",
              label: _vm.$t("actionTime"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: { prop: "task", label: "task", "min-width": "120" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "register_time",
              label: _vm.$t("registerTime"),
              "min-width": "120"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "last_login_time",
              label: _vm.$t("lastLoginTime"),
              "min-width": "150"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "recharge_amount",
              label: _vm.$t("roleRechargeAmount"),
              "min-width": "150"
            }
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          layout: "total,sizes, prev, pager, next",
          "current-page": _vm.paramsData.page,
          total: _vm.total
        },
        on: { "size-change": _vm.sizeChange, "current-change": _vm.getList }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }